<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
*{
  box-sizing: border-box;
}
html,body {
  margin: 0;
  padding: 0;
  height:100%;
  min-width: 1200px;
}
#app{
  width:100%;
  height:100%;
}
</style>
